module.exports = __webpack_public_path__ + "static/img/yinpin.58802694.png";